<script lang="ts" setup>
import LabelText from '~/components/form-elements/LabelText.vue'

const model = defineModel<boolean>()

const props = withDefaults(
  defineProps<{
    labelText?: string | null
    noText?: string | null
    yesText?: string | null
  }>(),
  { labelText: null, noText: 'Нет', yesText: 'Да' }
)
</script>

<template>
  <div>
    <LabelText v-if="labelText" class="mb-2" :value="labelText">
      <slot />
    </LabelText>

    <div class="yes-no-switch flex items-center">
      <span class="yes-no-switch__option cursor-pointer" :class="{ selected: !model }" @click="model = false">
        {{ noText }}
      </span>

      <label>
        <input v-model="model" type="checkbox">
        <span class="cursor-pointer" />
      </label>

      <span class="yes-no-switch__option cursor-pointer" :class="{ selected: model }" @click="model = true">
        {{ yesText }}
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use 'sass:color';

@use 'assets/css/variables';

.yes-no-switch {
  &__option {
    color: color.mix(variables.$main-gray-color, white, 60%);
    font-size: 16px;
    line-height: 16px;

    &.selected {
      color: variables.$main-gray-color;
    }
  }

  label {
    display: inline-block;
    height: 20px;
    margin: 0 10px;
    position: relative;
    width: 36px;

    input {
      height: 0;
      opacity: 0;
      width: 0;

      &:checked + span {
        background: variables.$main-green-color;

        &:before {
          transform: translateX(16px);
        }
      }
    }

    span {
      background: color.mix(variables.$main-gray-color, white, 20%);
      border-radius: 20px;
      bottom: 0;
      left: 0;
      position: absolute;
      right: 0;
      top: 0;
      transition: .15s;

      &:before {
        background: white;
        border-radius: 50%;
        bottom: 2px;
        content: '';
        height: 16px;
        left: 2px;
        position: absolute;
        transition: .15s;
        width: 16px;
      }
    }
  }
}
</style>
